module.exports = __webpack_public_path__ + "img/icon-fully-customizable.cc099cea.svg";